/**
 * @fileoverview GET handler for the "/app_settings/:app_group_id/message_prioritization/rules_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsAppGroupIdMessagePrioritizationRulesData } from "./constants";
import type { GetMessagePrioritizationRuleDataParams, MessagePrioritizationRulesDataResult } from "./types";
import { isMessagePrioritizationRulesDataResult } from "./validators";

export const getMessagePrioritizationRulesData = reactQueryFetcherAdapter(
  appSettingsAppGroupIdMessagePrioritizationRulesData,
  (
    signal: AbortSignal,
    { appGroupId, skipLastSeenUpdate }: GetMessagePrioritizationRuleDataParams
  ): Promise<MessagePrioritizationRulesDataResult> => {
    const queryParams = new URLSearchParams();
    if (skipLastSeenUpdate) {
      queryParams.append("skip_last_seen_update", "true");
    }
    const queryString = queryParams.toString();
    const url = queryString
      ? `/app_settings/${appGroupId}/message_prioritization/rules_data?${queryString}`
      : `/app_settings/${appGroupId}/message_prioritization/rules_data`;
    return fetch(url, "GET", {}, { signal });
  },
  isMessagePrioritizationRulesDataResult
);
